import { tokenService } from 'src/services';
import Services from 'src/services/Services';

export const BRANCH_BLOCKED_EVENT = 'branch-blocked-dialog-request';
export const BRANCH_STATUS_REFRESHED_EVENT = 'branch-status-refreshed';

export const isBranchBlocked = (branch) =>
  branch?.isBlocked === '1' || branch?.isBlocked === 1;

export const hasBranchWarning = (branch) =>
  Array.isArray(branch?.warnings)
    ? branch.warnings.length > 0
    : Boolean(branch?.warnings);

export const getWarningMessages = (branch) => {
  if (!Array.isArray(branch?.warnings)) return [];

  return branch.warnings
    .map((warning) =>
      typeof warning === 'string'
        ? warning
        : warning?.warningContent || warning?.message || ''
    )
    .map((message) => message.trim())
    .filter(Boolean);
};

export const getCurrentBranch = () => {
  const user = tokenService.getUser();
  if (user?.type !== 'corporational') return null;

  const branches = user?.authLocations?.branch;
  if (!Array.isArray(branches)) return null;

  const branchID = localStorage.getItem('branchID');
  return (
    branches.find((branch) => String(branch?.branchID) === String(branchID)) ||
    null
  );
};

export const isCurrentBranchBlocked = () => isBranchBlocked(getCurrentBranch());

export const canBranchCreateReservedJob = (branch) =>
  branch?.canCreateReservedJob === '1' ||
  branch?.canCreateReservedJob === 1 ||
  branch?.canCreateReservedJob === true;

export const canCurrentBranchCreateReservedJob = () =>
  canBranchCreateReservedJob(getCurrentBranch());

export const requestBlockedDialog = () => {
  window.dispatchEvent(new Event(BRANCH_BLOCKED_EVENT));
};

const getProfileAuthLocations = (profile) =>
  profile?.auth_locations ?? profile?.authLocations ?? null;

const getBranchWarnings = (branch) => branch?.warnings ?? branch?.warning;

const getBranchIsBlocked = (branch) => branch?.isBlocked ?? branch?.is_blocked;

const getBranchCanCreateReservedJob = (branch) =>
  branch?.canCreateReservedJob ?? branch?.can_create_reserved_job;

const getBranchID = (branch) => branch?.branchID ?? branch?.branch_id;

export const mergeBranchStatusFromProfile = (user, profile) => {
  const existingBranches = user?.authLocations?.branch;
  if (!Array.isArray(existingBranches)) return user;

  const freshBranches = getProfileAuthLocations(profile)?.branch;
  if (!Array.isArray(freshBranches) || freshBranches.length === 0) {
    return user;
  }

  const freshByID = new Map(
    freshBranches
      .map((branch) => [String(getBranchID(branch) ?? ''), branch])
      .filter(([id]) => id)
  );

  const updatedBranches = existingBranches.map((branch) => {
    const fresh = freshByID.get(String(branch?.branchID ?? ''));
    if (!fresh) return branch;

    return {
      ...branch,
      isBlocked: getBranchIsBlocked(fresh) ?? branch.isBlocked,
      warnings: getBranchWarnings(fresh) ?? branch.warnings,
      canCreateReservedJob:
        getBranchCanCreateReservedJob(fresh) ?? branch.canCreateReservedJob,
    };
  });

  return {
    ...user,
    authLocations: { ...user.authLocations, branch: updatedBranches },
  };
};

export const refreshCurrentBranchStatus = async () => {
  const user = tokenService.getUser();
  if (!user?.token || user?.type !== 'corporational') return;

  try {
    const response = await Services.GetProfile(user.token);
    if (!response?.data?.status) return;

    const updatedUser = mergeBranchStatusFromProfile(
      user,
      response.data.result
    );

    if (updatedUser !== user) {
      localStorage.setItem('user', JSON.stringify(updatedUser));
      window.dispatchEvent(new Event(BRANCH_STATUS_REFRESHED_EVENT));
    }
  } catch (error) {}
};
